export default __webpack_public_path__ + "static/media/summerchallenge08.a059761b.jpg";